module.exports = __webpack_public_path__ + "img/love.377b617e.svg";